module.exports = "/static/assets/8771556be854985a93e479eecb02fad7.png";